import styled from "styled-components";
import { useChat } from "../context/ChatContext";
import EmptyChat from "./EmptyChat";
import Question from "./Question";
import Answer from "./Answer";
import LoadingAnswer from "./LoadingAnswer";
import { useEffect, useRef, useState } from "react";

import atchezaMarkerIcon from "../assets/images/atcheza-marker.png";

const Container = styled.div`
  flex: 1;
  overflow-y: auto;

  display: flex;
  flex-direction: column;
  word-wrap: break-word;
  word-break: break-word;

  gap: 1.5rem;
  padding-right: 1rem;
  padding-left: 1rem;
`;

const AnswerContainer = styled.div`
  align-self: flex-start;
  max-width: 80%;
`;

const AnswerContent = styled.div`
  display: flex;
  gap: 1rem;
`;

const Avatar = styled.div`
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background-color: #0c798b;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const AvatarIcon = styled.img`
  width: 70%;
  height: auto;
  display: block;
`;

function DialogWindow() {
  const scrollContainerRef = useRef(null);
  const [isUserScrolling, setIsUserScrolling] = useState(false);

  const { conversation, loadingAnswer, setConversation } = useChat();

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = container;

      const atBottom = scrollTop + clientHeight >= scrollHeight - 10;
      setIsUserScrolling(!atBottom);
    };

    container.addEventListener("scroll", handleScroll);
    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (isUserScrolling) return;

      const container = scrollContainerRef.current;
      if (!container) return;

      const lastChild = container.lastElementChild;
      if (lastChild) {
        lastChild.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);

    return () => clearInterval(interval);
  }, [isUserScrolling]);

  useEffect(() => {
    const history = localStorage.getItem("chat-dialog");
    if (history) {
      setConversation(JSON.parse(history));
    }
  }, [setConversation]);

  return (
    <Container ref={scrollContainerRef}>
      {!conversation.length && <EmptyChat />}

      {
        <>
          {conversation.map((message, index) =>
            message.type === "question" ? (
              <Question message={message} key={`question-${index}`} />
            ) : (
              <AnswerContainer key={`answer-${index}`}>
                <AnswerContent>
                  <Avatar>
                    <AvatarIcon
                      src={atchezaMarkerIcon}
                      alt=""
                      loading="lazy"
                    />
                  </Avatar>
                  <Answer message={message} />
                </AnswerContent>
              </AnswerContainer>
            )
          )}
          {loadingAnswer && <LoadingAnswer />}
        </>
      }

      <div id="scroll-smooth" />
    </Container>
  );
}

export default DialogWindow;
